import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { authLoginRoute } from './auth.routes';

type Args = {
  request: Request;
};

export function redirectRequireAuthentication({ request }: Args) {
  const url = new URL(request.url);

  return idealistRedirect({ request })(
    authLoginRoute.with({
      to: `${url.pathname}${url.search}`,
      // Use auth_required on hypernova
      auth_required: HORIZON_ENABLED ? undefined : 1,
    }),
    { flashMessage: { type: 'LOGIN_REQUIRED' }, status: 302 },
  );
}
